import React, { useState, useContext, useReducer, useEffect } from 'react';
import { List, Page } from '../../components';
import { GoodsSelect, GoodsPriceEdit, GoodsPriceBatchEdit } from '..';
import {
  getGoodsList,
  getGoodsSpecPriceList,
  insertGoodsPrice,
  updateGoodsPrice,
  insertGoods,
  deleteGoods,
  checkCanDeleteGoods,
  updatePackageSize,
  getGoodsListByDatetime,
} from '../../services/Buyer';
import moment from 'moment';
import {
  Row, Col,
  Divider,
  Button,
  Tabs,
  Form,
  InputNumber,
  Modal,
  message,
  Select,
  Checkbox
} from 'antd';
import {
  CloseOutlined,
  DollarOutlined,
  PlusOutlined,
  ExclamationCircleOutlined,
  SaveOutlined
} from '@ant-design/icons';
import { MasterContext } from '../../App';
import './style';
import FormItem from 'antd/lib/form/FormItem';

const { TabPane } = Tabs;
export default React.forwardRef((props, ref) => {
  const { buyer, onCloseCallback } = props;
  const { currency, currentUser, authorities, goods_category } = useContext(MasterContext);
  const [isShowGoodsSelect, setShowGoodsSelect] = useState(false);
  const [isShowPriceEdit, setShowPriceEdit] = useState(false);
  const [isShowBatchPriceEdit, setShowBatchPriceEdit] = useState(false);
  const [isShowPriceNew, setShowPriceNew] = useState(false);
  const [goodsList, setGoodsList] = useState([]);
  const [goodsPriceList, setGoodsPriceList] = useState([]);
  const [selectedGoodsIndex, setSelectedGoodsIndex] = useState(-1);
  const [selectedPriceIndex, setSelectedPriceIndex] = useState(-1);
  const [filterGoodsId, setFilterGoodsId] = useState(undefined);

  let goodsListItem = [];
  if (filterGoodsId) {
    goodsListItem = goodsList.filter(x => x.goods_id === filterGoodsId).map((item, index) => {
      return Object.assign({
        editable: false,
        deletable: authorities.find(x => x === 'create_buyer' || x === 'edit_buyer') || currentUser.category_id === 1
      }, item);
    });
  } else {
    goodsListItem = goodsList.map((item, index) => {
      return Object.assign({
        editable: false,
        deletable: authorities.find(x => x === 'create_buyer' || x === 'edit_buyer') || currentUser.category_id === 1
      }, item);
    });
  }

  const selectedGoods = goodsListItem[selectedGoodsIndex] || {};
  const selectedGoodsPrice = goodsPriceList[selectedPriceIndex] || {};

  const getBuyerGoodsListAndPrice = (dt) => {
    return getGoodsListByDatetime(buyer.id, dt);
  }

  const onChangeCountPerCarton = (value) => {
    const temp = [].concat(goodsList);
    const goods = temp.find(x => x.goods_id === selectedGoods.goods_id && x.goods_spec_id === selectedGoods.goods_spec_id);
    if (goods) {
      goods.pcs_per_carton = value;
      setGoodsList(temp);
    }
  }

  const onChangeCartonCountPerPallet = (value) => {
    const temp = [].concat(goodsList);
    const goods = temp.find(x => x.goods_id === selectedGoods.goods_id && x.goods_spec_id === selectedGoods.goods_spec_id);
    if (goods) {
      goods.carton_count_per_pallet = value;
      setGoodsList(temp);
    }
  }

  const onChangeIsFlower = (value) => {
    const temp = [].concat(goodsList);
    const goods = temp.find(x => x.goods_id === selectedGoods.goods_id && x.goods_spec_id === selectedGoods.goods_spec_id);
    if (goods) {
      goods.is_flower = value;
      setGoodsList(temp);
    }
  }
  const onSaveCartonCount = () => {
    if (!selectedGoods.carton_count_per_pallet) {
      return;
    }
    try {
      const key = 'update_goods_package_size';
      console.log('onSaveCartonCount:', selectedGoods.goods_name);
      message.loading({ content: `正在更新产品包装尺寸 [${selectedGoods.goods_name}]...`, key });
      updatePackageSize(
        buyer.id,
        selectedGoods.goods_id,
        selectedGoods.goods_spec_id,
        {
          carton_count_per_pallet: selectedGoods.carton_count_per_pallet,
          pcs_per_carton: selectedGoods.pcs_per_carton,
          is_flower: selectedGoods.is_flower
        }
      ).then(() => {
        message.success({ content: `更新产品包装尺寸成功 [#${selectedGoods.goods_name}]`, key, duration: 2 });
      });
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }
  const onClose = () => {
    try {
      if (onCloseCallback) {
        onCloseCallback();
      }
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const reloadGoods = () => {
    var p1 = new Promise((resolve, reject) => {
      getGoodsList(buyer.id).then(goods => {
        setGoodsList(goods);
        resolve(true);
      });
    });
    return Promise.all([p1]).then(values => {
      //setLoadding(false);
    });
  }

  const reloadGoodsPrice = () => {
    var p1 = new Promise((resolve, reject) => {
      getGoodsSpecPriceList(buyer.id, selectedGoods.goods_id, selectedGoods.goods_spec_id).then(data => {
        setGoodsPriceList(data);
        resolve(true);
      });
    });
    return Promise.all([p1]).then(values => {
      //setLoadding(false);
    });
  }

  useEffect(() => {
    getGoodsList(buyer.id).then(goods => {
      setGoodsList(goods);
      if (goods.length > 0) {
        setSelectedGoodsIndex(0);
      }
    });
  }, []);

  useEffect(() => {
    if (selectedGoodsIndex > -1) {
      getGoodsSpecPriceList(buyer.id, selectedGoods.goods_id, selectedGoods.goods_spec_id).then((data) => {
        setGoodsPriceList(data);
      })
    } else {
      setGoodsPriceList([]);
    }
  }, [selectedGoodsIndex]);

  const onGoodsSelect = (goods) => {
    if (goods.length === 0) {
      setShowGoodsSelect(false);
      return;
    }
    try {
      const key = 'create_buyer_goods';
      console.log('onSave:', goods);
      message.loading({ content: `正在新建客户产品 [${buyer.name_cn}]...`, key });
      insertGoods(buyer.id, goods).then(() =>
        getGoodsList(buyer.id).then(goods => {
          setGoodsList(goods);
          setShowGoodsSelect(false);
          setSelectedGoodsIndex(goods.length - 1);
          message.success({ content: `新建客户产品成功 [#${buyer.name_cn}]`, key, duration: 2 });
        }));
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onDeleteGoods = (goods) => {
    try {
      const key = 'delete_buyer_goods';
      console.log('onDeleteGoods:', goods);

      checkCanDeleteGoods(buyer.id, goods.goods_id, goods.goods_spec_id).then(data => {
        if (data.length > 0) {
          Modal.error({
            title: '删除错误',
            content: <span>
              <strong>该产品已被下列订单使用，不能删除。</strong><br />
              {
                data.map(x => {
                  return <div><strong>{x.po_code}</strong> - {x.no}</div>
                })
              }
            </span>,
          });
          return;
        }
        message.loading({ content: `正在删除客户产品 [${goods.goods_name}-${goods.goods_spec_name}]...`, key });
        deleteGoods(buyer.id, goods.goods_id, goods.goods_spec_id).then(() =>
          getGoodsList(buyer.id).then(data => {
            setGoodsList(data);
            if (goodsListItem.length > 0) {
              setSelectedGoodsIndex(0);
            }
            message.success({ content: `删除客户产品成功 [${goods.goods_name}-${goods.goods_spec_name}]`, key, duration: 2 });
          }));
      });

    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }
  const showDeleteConfirm = (index, item) => {
    Modal.confirm({
      title: '确定删除当前产品吗?',
      icon: <ExclamationCircleOutlined />,
      content: <strong>{item.goods_name}-{item.goods_spec_name}</strong>,
      okText: 'Yes',
      centered: true,
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        onDeleteGoods(item);
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const onEditPrice = (index) => {
    setSelectedPriceIndex(index);
    setShowPriceEdit(true);
  }

  const onNewPriceCallback = (values) => {
    try {
      const key = 'insert_buyer_goods_price';
      console.log('onNewPriceCallback:', values);
      message.loading({ content: `正在添加产品价格 [${selectedGoods.goods_name}-${selectedGoods.goods_spec_name}]...`, key });
      insertGoodsPrice(
        buyer.id,
        selectedGoods.goods_id,
        selectedGoods.goods_spec_id,
        Object.assign({
          start_time: moment(new Date()).format('yyyy-MM-DD HH:mm:ss'),
          end_time: moment(new Date()).format('2099-12-31 23:59:59')
        }, values)
      ).then(() =>
        reloadGoodsPrice().then(() => {
          setShowPriceNew(false);
          message.success({ content: `添加产品价格成功 [${selectedGoods.goods_name}-${selectedGoods.goods_spec_name}]`, key, duration: 2 });
        }));
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onBatchEditPriceCallback = (values, callback) => {
    values.forEach((x, i) => {
      try {
        const key = 'edit_buyer_goods_price';
        console.log('onEditPriceCallback:', x);
        message.loading({ content: `正在修改产品价格 [${x.goods_name}-${x.goods_spec_name}]...`, key });
        insertGoodsPrice(
          buyer.id,
          x.goods_id,
          x.goods_spec_id,
          x
        ).then(() => {
          message.success({ content: `修改产品价格成功 [${x.goods_name}-${x.goods_spec_name}]`, key, duration: 2 })
          if (i === values.length - 1) {
            reloadGoodsPrice().then(() => {
              callback && callback();
            })
          }
        });
      } catch (errInfo) {
        console.log('Error:', errInfo);
      }
    })

  }

  const onEditPriceCallback = (values) => {
    const date = moment(new Date()).format('yyyy-MM-DD HH:mm:ss');
    try {
      const key = 'edit_buyer_goods_price';
      console.log('onEditPriceCallback:', values);
      message.loading({ content: `正在修改产品价格 [${selectedGoods.goods_name}-${selectedGoods.goods_spec_name}]...`, key });
      insertGoodsPrice(
        buyer.id,
        selectedGoods.goods_id,
        selectedGoods.goods_spec_id,
        Object.assign({
          start_time: date,
          end_time: moment(new Date()).format('2099-12-31 23:59:59')
        }, values)
      ).then(() =>
        reloadGoodsPrice().then(() => {
          setShowPriceEdit(false);
          message.success({ content: `修改产品价格成功 [${selectedGoods.goods_name}-${selectedGoods.goods_spec_name}]`, key, duration: 2 });
        })
      );
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }


  const onGoodsSelected = (index) => {
    //const temp = goodsListItem[index];
    //const idx = goodsList.indexOf(goodsList.find(x => x.goods_id === temp.goods_id && x.goods_spec_id === temp.goods_spec_id));
    setSelectedGoodsIndex(index);
  }

  const goodsOptions = [];
  goodsList.forEach(x => {
    if (!goodsOptions.find(y => y.id === x.goods_id)) {
      goodsOptions.push({ id: x.goods_id, prefix: x.prefix, name: x.goods_name });
    }
  });
  const priceListItem = goodsPriceList.map((item, index) => {
    const start_time = moment(item.start_time);
    const end_time = moment(item.end_time)
    return Object.assign({
      default: end_time.diff(moment(new Date()), 'seconds') < 1 ? false : true,
      editable: end_time.diff(moment(new Date()), 'seconds') < 1 ? false : (authorities.find(x => x === 'create_buyer' || x === 'edit_buyer') || currentUser.category_id === 1),
      deletable: start_time.diff(moment(new Date()), 'seconds') < 1 ? false : (authorities.find(x => x === 'create_buyer' || x === 'edit_buyer') || currentUser.category_id === 1)
    }, item);
  });

  const symbol = (currency.find(x => x.id === buyer.currency_id) || {}).symbol;

  const operations = <Button disabled={goodsList.length === 0} type="primary" onClick={() => setShowBatchPriceEdit(true)} size="small">产品一览&批量修改价格</Button>;
  return (
    <div style={{ padding: '0 1rem' }}>
      <Row>
        <Col span={8}>
          <List
            selectable={true}
            title={
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <strong>产品列表&nbsp;&nbsp;
                  <Select
                    optionFilterProp="children"
                    allowClear
                    showSearch
                    onChange={setFilterGoodsId}
                    style={{ width: '200px' }}
                    size="small">
                    {
                      goodsOptions.map(x => {
                        return <Select.Option value={x.id}>
                          [{x.prefix}] - {x.name}
                        </Select.Option>
                      })
                    }
                  </Select></strong>
                {(authorities.find(x => x === 'create_buyer' || x === 'edit_buyer') || currentUser.category_id === 1) && <Button type="primary" onClick={() => setShowGoodsSelect(true)} icon={<PlusOutlined />} size="small">添加产品</Button>}
              </div>
            }
            emptyContent={<span>暂无产品, 点击<Button onClick={() => setShowGoodsSelect(true)} type="link">添加产品</Button></span>}
            onDelete={showDeleteConfirm}
            footer={<div style={{ textAlign: 'right' }}>共{goodsList.length}项</div>}
            bordered={true}
            rows={goodsListItem}
            renderItem={(item, index) => {
              return <div>[{item.goods_name}]-{item.goods_spec_name} <strong>{item.size}</strong>   [{item.carton_count_per_pallet}箱/托]</div>
            }}
            onSelected={onGoodsSelected}
            selected={selectedGoodsIndex}
          />
        </Col>
        <Col span={16} >
          <Tabs style={{ marginLeft: '2rem' }} tabBarExtraContent={operations}>
            <TabPane tab={<span>价格体系({currency.find(x => x.id === buyer.currency_id).name})</span>} key="1">
              {
                <List
                  title={null}
                  bordered={true}
                  rows={priceListItem}
                  emptyContent={
                    <div style={{ padding: '6rem', width: '100%', textAlign: 'center' }}>
                      该产品暂无价格,点击
                    <Button onClick={() => setShowPriceNew(true)} style={{ padding: 0 }} type="link">添加价格</Button>
                    </div>}
                  renderItem={(item, index) => {
                    if (!item.default) {
                      return <div style={{ fontSize: '1.25rem' }}>{item.start_time} - {item.end_time}  <span>{symbol}{item.price}/PCS</span> </div>
                    } else {
                      return <div style={{ fontSize: '1.25rem' }}><strong>{item.start_time} - {item.end_time}  <span style={{ color: 'red' }}>{symbol}{item.price}/PCS</span></strong></div>
                    }
                  }}
                  onEdit={onEditPrice}
                />
              }
            </TabPane>
            <TabPane tab="包装尺寸" key="2">
              <div style={{ padding: '1rem 0' }}>
                <Row>
                  <Col span={24}>
                    <Form.Item label="箱数 / 托盘" rules={[{ required: true }]}>
                      <InputNumber onChange={(value) => onChangeCartonCountPerPallet(value)} value={selectedGoods.carton_count_per_pallet} style={{ width: '100%' }} min={1} max={99999} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <Form.Item label="件数&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;箱" rules={[{ required: true }]}>
                      <InputNumber onChange={(value) => onChangeCountPerCarton(value)} value={selectedGoods.pcs_per_carton} style={{ width: '100%' }} min={1} max={99999} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Form.Item label="是否花篮托">
                    <Checkbox onChange={(e)=>onChangeIsFlower(e.target.checked)} checked={selectedGoods.is_flower} />
                  </Form.Item>
                </Row>
                <br />
                <Row justify="end">
                  <Col flex="94px">
                    <Button onClick={onSaveCartonCount} type="primary" icon={<SaveOutlined />}>保存</Button>
                  </Col>
                </Row>
              </div>
            </TabPane>
          </Tabs>
        </Col>
      </Row>
      <Divider style={{ margin: '1rem 0' }} />
      <div className="page-footer">
        <div></div>
        <Button onClick={onClose} icon={<CloseOutlined />}>关 闭</Button>
      </div>
      <Page
        title="产品选择"
        width="1024px"
        onCloseCallback={() => setShowGoodsSelect(!isShowGoodsSelect)}
        body={<GoodsSelect filteredGoods={goodsList} onOk={onGoodsSelect} />}
        visible={isShowGoodsSelect}
      />
      <Page
        title={`新建价格 [ ${buyer.name_en} ]`}
        width="50vw"
        onCloseCallback={() => setShowPriceNew(!isShowPriceNew)}
        body={<GoodsPriceEdit
          goodsName={selectedGoods.goods_name}
          goodsSpecName={selectedGoods.goods_spec_name}
          onSaveCallback={onNewPriceCallback}
          onClose={() => setShowPriceNew(!isShowPriceNew)}
        />}
        visible={isShowPriceNew}
      />
      <Page
        title={`修改价格 [ ${buyer.name_en} ]`}
        width="50vw"
        onCloseCallback={() => setShowPriceEdit(!isShowPriceEdit)}
        body={<GoodsPriceEdit
          goodsName={selectedGoods.goods_name}
          goodsSpecName={selectedGoods.goods_spec_name}
          onSaveCallback={onEditPriceCallback}
          price={selectedGoodsPrice.price}
          onClose={() => setShowPriceEdit(!isShowPriceEdit)}
        />}
        visible={isShowPriceEdit}
      />
      <Page
        title={`批量修改价格 [ ${buyer.name_en} ]`}
        isMaximize={true}
        onCloseCallback={() => setShowBatchPriceEdit(false)}
        body={<GoodsPriceBatchEdit
          goodsCategory={goods_category}
          precision={4}
          getGoodsList={getBuyerGoodsListAndPrice}
          onSaveCallback={onBatchEditPriceCallback}
          onCloseCallback={() => setShowBatchPriceEdit(false)}
        />}
        visible={isShowBatchPriceEdit}
      />
    </div>
  )
});
